import styled from "@emotion/styled";
import type { FunctionComponent } from "react";

import type {
  ContentSchemaRenderProps,
  RenderComponent,
} from "scmp-app/components/schema-render/content";

import { Blockquote, Container, Figcaption, StyledQuoteIcon } from "./styles";

type Props = {
  className?: string;
} & ContentSchemaRenderProps;

export const Component: FunctionComponent<Props> = ({ className, schemaNode }) => {
  const [quoteNode, sourceNode] = schemaNode.children ?? [];
  return (
    <Container className={className}>
      <StyledQuoteIcon />
      <Blockquote>{quoteNode?.data}</Blockquote>
      <Figcaption>{sourceNode?.data}</Figcaption>
    </Container>
  );
};

export const PrintArticleBlockquoteQuote: RenderComponent<Props> = styled(Component)``;

PrintArticleBlockquoteQuote.isHandlingOwnChildren = true;
PrintArticleBlockquoteQuote.displayName = "PrintArticleBlockquoteQuote";
